import apiService from "./api.service";
import authService from "./auth.service";
import { logout } from "../helpers/logout";

const get = async ({ role }) => {
  const userToken = await authService.getAuthToken()
  return fetch(apiService.getEndpointbyRole(role, "ETA"), {
    method: "GET",
    headers: {
      Authorization: userToken,
    },
  })
    .then((response) => response.json())
    .then((data) => {
      return data;
    })
    .catch((err) => {logout(err)});
};

const estimatedTimeArrivalService = {
  get,
};

export default estimatedTimeArrivalService;
